'use client';

import UiPageTitle from '@umodeapporg/ui/components/Navigation/PageTitle';
import { ComponentProps } from 'react';

import { AjudaDaTela } from '@/components/layout/AjudaDaTela';

type PageTitleProps = ComponentProps<typeof UiPageTitle>;

/**
 * The library header, title in the library's own colour as in the dashboard. Every route
 * imports PageTitle from HERE instead of the library, for the two defaults below.
 *
 * `capitalizeTitle` is OFF by default here. The library capitalises EVERY word, which turned
 * the headers into "Carteira De OPs" and "Fila De Atenção" while the menu right beside them
 * read "Carteira de OPs". The titles already arrive written the way they should be read, so
 * the screen stops rewriting them. Buttons are handled the same way, by a rule in
 * `globals.css`: the library stamps `capitalize` into their base class.
 *
 * The "?" of this screen rides along in `titleSlot`, beside the title: every route goes
 * through here, so no screen is born without its way into the manual. It sits on the LEFT,
 * next to the name of the screen it explains, and leaves `slot` to the page's own actions.
 * A page that passes its own `titleSlot` keeps it, with the "?" first.
 */
export default function PageTitle({ capitalizeTitle = false, titleSlot, ...props }: PageTitleProps) {
  return (
    <UiPageTitle
      {...props}
      capitalizeTitle={capitalizeTitle}
      titleSlot={
        <>
          <AjudaDaTela />
          {titleSlot}
        </>
      }
    />
  );
}
